import { Dialog } from '@base-ui/react/dialog'
import { SidebarContent } from './SidebarContent'

interface MobileSidebarDrawerProps {
  readonly open: boolean
  readonly onClose: () => void
}

/**
 * Drawer lateral que substitui a sidebar fixa abaixo de `lg` (1024px).
 * Aberto pelo hambúrguer no `<Header>`. Fecha por: backdrop, ESC (via
 * Base UI Dialog), navegação (controlado pelo `<AppShell>`).
 */
export function MobileSidebarDrawer({ open, onClose }: MobileSidebarDrawerProps) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-40 bg-black/50 lg:hidden" />
        <Dialog.Popup className="fixed inset-y-0 left-0 z-50 flex h-full w-64 flex-col border-r border-border bg-sidebar shadow-xl lg:hidden">
          <Dialog.Title className="sr-only">Menu de navegação</Dialog.Title>
          <SidebarContent onNavigate={onClose} />
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
